import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import { Modal } from "../../../components/Modal"
import { Button } from "../../../components/Button"
import { AutoComplete } from "../../../components/AutoComplete"
import autoCompleteStyles from "../../../components/AutoComplete/autoCompleteStyles"
import { CreateTrailerWarranty } from "../../../api/api.service"

const ManageImportGlobalWarrantyModal = ({
   isOpen = false,
   onToggleModal = () => {},
   warrantiesOptions = {},
   setWarrantiesOptions = () => {},
   handleSearchWarranty = () => {},
   selectedWarranties = [],
   setSelectedWarranties = () => {},
   trailerId = "",
   onSuccess = () => {},
   existingTrailerWarranties = [],
}) => {
   const [isLoading, setIsLoading] = useState(false)
   const [existingWarrantyIds, setExistingWarrantyIds] = useState([])

   useEffect(() => {
      const ids = existingTrailerWarranties.map(
         warranty => warranty?.configuratorWarranties?.id
      )
      setExistingWarrantyIds(ids)
   }, [existingTrailerWarranties])

   const hasExistingDefaultWarranty = existingTrailerWarranties.some(
      warranty => warranty.isDefault === true
   )

   const hasSelectedDefaultWarranty = selectedWarranties.some(
      warranty => warranty.isDefault === true
   )

   const handleSelectWarranties = selectedOptions => {
      setSelectedWarranties(selectedOptions || [])
   }

   const handleRemoveChip = warrantyToRemove => {
      const updatedWarranties = selectedWarranties.filter(
         warranty => warranty.value !== warrantyToRemove.value
      )
      setSelectedWarranties(updatedWarranties)
   }

   const handleSubmit = async () => {
      if (!selectedWarranties || selectedWarranties.length === 0) {
         toast.error("Please select at least one warranty")
         return
      }

      try {
         setIsLoading(true)
         const warrantyIds = selectedWarranties.map(warranty => warranty.value)

         const payload = {
            configuratorTrailerId: Number(trailerId),
            globalWarrantyIds: warrantyIds,
         }

         await CreateTrailerWarranty(payload)
         toast.success(
            `${selectedWarranties.length} warranty(s) added successfully!`
         )
         onToggleModal()
         setSelectedWarranties([])
         onSuccess()
      } catch (error) {
         toast.error("Failed to add warranties")
      } finally {
         setIsLoading(false)
      }
   }

   const handleModalClose = () => {
      setSelectedWarranties([])
      setWarrantiesOptions(prev => {
         return {
            ...prev,
            page: 1,
            Q: "",
         }
      })
      onToggleModal()
   }

   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={handleModalClose}
         bodyClassName=""
         customButton={true}
         hideModalHeaderSeparator={true}
         headerClasses="header-container mb-0"
         size="md"
         backdrop="static"
         modalTitle="Select Warranties"
         scrollable
      >
         <div style={{ pointerEvents: isLoading ? "none" : "auto" }}>
            <Row>
               <Col xs={12}>
                  <div className="mb-3">
                     <AutoComplete
                        isMulti
                        handleBlur={() =>
                           setWarrantiesOptions(prev => {
                              return {
                                 ...prev,
                                 page: 1,
                                 Q: "",
                              }
                           })
                        }
                        onChange={handleSelectWarranties}
                        onInputChange={handleSearchWarranty}
                        placeholder="Select warranties"
                        classNamePrefix="status-header-search-admin"
                        customStyles={autoCompleteStyles.STYLE_TEN}
                        options={warrantiesOptions?.data}
                        isClearable={true}
                        value={selectedWarranties}
                        isLoading={warrantiesOptions?.fetching}
                        closeMenuOnSelect={false}
                        menuPortalTarget={document.body}
                        isOptionDisabled={option =>
                           existingWarrantyIds.includes(option.value) ||
                           (hasExistingDefaultWarranty &&
                              option.isDefault === true) ||
                           (hasSelectedDefaultWarranty &&
                              option.isDefault === true &&
                              !selectedWarranties.some(
                                 selected => selected.value === option.value
                              ))
                        }
                     />
                  </div>

                  <div className="mb-3">
                     <div className="Global-selected-features-container">
                        {selectedWarranties && selectedWarranties.length > 0 ? (
                           <div className="d-flex flex-wrap gap-2">
                              {selectedWarranties.map((warranty, index) => (
                                 <span
                                    key={`${warranty.value}-${index}`}
                                    className="Global-feature-chip"
                                 >
                                    <span>{warranty.label}</span>
                                    <button
                                       type="button"
                                       onClick={() =>
                                          handleRemoveChip(warranty)
                                       }
                                       aria-label="Remove"
                                       className="Global-feature-chip-remove-btn"
                                    >
                                       ×
                                    </button>
                                 </span>
                              ))}
                           </div>
                        ) : (
                           <div className="no-features-selected">
                              No warranties selected
                           </div>
                        )}
                     </div>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                     <Button
                        isLoading={isLoading}
                        type="button"
                        title="Save"
                        className="header-button"
                        onClick={handleSubmit}
                     />
                  </div>
               </Col>
            </Row>
         </div>
      </Modal>
   )
}

export default ManageImportGlobalWarrantyModal
